import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './BankSelector.scss'
import { IGoCardlessBankItem } from 'interfaces/i-gocardless'

type IBankSelectorProps = {
	items: IGoCardlessBankItem[]
	selectedItem?: IGoCardlessBankItem
	onSelect: (item: IGoCardlessBankItem) => void
}

const BankSelector: React.FC<IBankSelectorProps> = ({
	items,
	selectedItem,
	onSelect,
}) => {
	const { t } = useTranslation()
	const [search, setSearch] = useState('')

	const filteredItems = items.filter((item) =>
		item.name.toLowerCase().includes(search.toLowerCase()),
	)

	return (
		<div className="bank-selector-container">
			<input
				id="bank-selector-search"
				type="text"
				placeholder={t('BankSearch')}
				value={search}
				onChange={(e) => setSearch(e.target.value)}
				className="bank-search"
			/>
			<div className="banks-list-container">
				{filteredItems.map((item) => {
					const isSelected = selectedItem?.id === item.id

					return (
						<div
							key={item.id}
							id={`bank-selector-item-${item.id}`}
							onClick={() => onSelect?.(item)}
							className={
								isSelected ? 'bank-item-selected' : 'bank-item'
							}>
							<img src={item.logo} alt={item.name} />

							<div>{item.name}</div>
						</div>
					)
				})}
				{filteredItems.length === 0 && <p>{t('BanksListEmpty')}</p>}
			</div>
		</div>
	)
}

export default BankSelector
